import { useEffect, useState } from 'react';
import { useMatch } from 'react-router-dom';

import { useCurrentUser, useEvent, useSession } from '@bizzabo/entities';

import { useSocket } from '../../../contexts/Socket';
import { QnaAttendeeSocket } from '../api/socket';
import useQnaSession from './useQnaSession';
import { IQuestion } from '../types';
import useVenueRoute from 'hooks/useVenueUrl/useVenueRoute';

const useQnaNotification = (eventUniqueName: string) => {
    const [hasNewQnaNotification, setHasNewQnaNotification] = useState<boolean>(false);
    const route = useVenueRoute('/agenda/activity/:activityId');
    const activityMatch = useMatch(route);
    const params = activityMatch?.params;
    const sessionId = params?.activityId ? Number(params?.activityId) : undefined;

    const event = useEvent(eventUniqueName);
    const session = useSession(event.data?.id, sessionId);
    const { qnaEntity } = useQnaSession(event.data, session.data);
    const { data: currentUser } = useCurrentUser(event.data?.id);

    const { socket, isConnected } = useSocket();
    const qnaSocket = new QnaAttendeeSocket(socket);

    useEffect(() => {
        if (isConnected && !!qnaEntity) {
            qnaSocket.onQuestionApprove({
                entityId: qnaEntity.id,
                cb: (question: IQuestion | null) => {
                    if (currentUser?.userProfileId !== question?.askedBy) {
                        setHasNewQnaNotification(true);
                    }
                },
            });
        }

        return () => {
            if (isConnected) {
                qnaSocket.close();
            }
        };
    }, [isConnected, qnaEntity]);

    const resetQnaNotification = () => {
        setHasNewQnaNotification(false);
    };

    return {
        hasNewQnaNotification,
        resetQnaNotification,
    };
};

export default useQnaNotification;
